import { searchScheduleApi } from "../../../api/api";

const actions = {
    async scheduleListAction(context, params) {
        try {
            const result = await searchScheduleApi(params);
            return new Promise((resolve, reject) => {
                if (result.status === 0) {
                    context.commit('scheduleListMutation', result.data);
                    resolve(result.data);
                }
                else reject(result.status);
            });
        } catch (error) {
            console.log(error);
        }
    },

    tempDateAction(context, params) {
        context.commit('tempDateMutation', params);
    }

};

export default actions;
